import createFocusTrap from 'focus-trap';
import $ from 'jquery';
import ArrowBigNext from '../../../img/rolex-v7/icons/rlx-v7-arrow--right.svg';

export default function rlxModelLightbox() {
    const htmlElement = document.documentElement;
    const lightbox = document.querySelector('.js-rlx-v7-watch-gallery-lightbox');
    const slider = document.querySelector('.js-rlx-v7-watch-gallery-lightbox__slide');
    const closeBtn = document.querySelector('.js-rlx-v7-watch-gallery-lightbox__close');
    const tiles = document.querySelectorAll('.js-gallery-tile');

    if (tiles.length === 0 || !slider) return;

    let sliderInitialized = false;

    const $slider = $(slider);
    const nextText = $slider.data('js-a11y-next-slide') || 'Next slide';
    const prevText = $slider.data('js-a11y-previous-slide') || 'Previous slide';

    const nextArrowHtml = `<button type="button" class="slick-next rlx-v7-icon-button rlx-v7-icon-button--round is-dark"><span class="rlx-v7-icon-button__icon">${ArrowBigNext}</span><span class="_visuallyhidden">${nextText}</span></button>`;
    const prevArrowHtml = `<button type="button" class="slick-prev rlx-v7-icon-button rlx-v7-icon-button--round is-dark"><span class="rlx-v7-icon-button__icon">${ArrowBigNext}</span><span class="_visuallyhidden">${prevText}</span></button>`;

    const focusTrapModal = createFocusTrap(lightbox, {
        initialFocus: closeBtn,
        escapeDeactivates: true,
        delayInitialFocus: true,
    });

    tiles.forEach((tile) => {
        tile.addEventListener('click', () => {
            const index = parseInt(tile.getAttribute('data-index'), 10);
            lightbox.classList.add('is--visible');
            htmlElement.classList.add('no--scroll');

            setTimeout(() => {
                focusTrapModal.activate();
            }, 100);

            if (!sliderInitialized) {
                $slider.not('.slick-initialized').slick({
                    infinite: false,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    nextArrow: nextArrowHtml,
                    prevArrow: prevArrowHtml,
                });

                const $threesixtyContainer = $slider.find('.js-threesixty');
                if ($threesixtyContainer.length) {
                    $threesixtyContainer.on('mouseenter touchstart', () => {
                        $slider.slick('slickSetOption', 'swipe', false, false);
                        $slider.slick('slickSetOption', 'draggable', false, false);
                    });

                    $threesixtyContainer.on('mouseleave touchend touchcancel', () => {
                        $slider.slick('slickSetOption', 'swipe', true, true);
                        $slider.slick('slickSetOption', 'draggable', true, true);
                    });
                }

                sliderInitialized = true;
            }
            $slider.slick('slickGoTo', index);
        });

        tile.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                tile.click();
            }
        });
    });

    const closeLightbox = () => {
        htmlElement.classList.remove('no--scroll');
        lightbox.classList.remove('is--visible');
        focusTrapModal.deactivate();

        // 1. Event-Sperren des 360°-Containers komplett vom DOM lösen
        const $threesixtyContainer = $slider.find('.js-threesixty');
        if ($threesixtyContainer.length) {
            $threesixtyContainer.off('mouseenter touchstart mouseleave touchend touchcancel');
        }

        // 2. Die Slick-Instanz der Lightbox komplett zerstören (Reset)
        if ($slider.hasClass('slick-initialized')) {
            // Erst die Optionen zur Sicherheit zurücksetzen...
            $slider.slick('slickSetOption', 'swipe', true, true);
            $slider.slick('slickSetOption', 'draggable', true, true);
            // ...und dann die Instanz komplett killen
            $slider.slick('unslick');
        }

        // 3. Status-Variable zurücksetzen, damit der Slider beim nächsten Öffnen neu baut
        sliderInitialized = false;
    };

    closeBtn.addEventListener('click', closeLightbox);

    document.addEventListener('keydown', (event) => {
        if ((event.key === 'Escape' || event.key === 'Esc') && lightbox.classList.contains('is--visible')) {
            closeLightbox();
        }
    });
}
